import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { DevToolsGuardHandle, DevToolsGuardService } from './devtools-guard.service';
import { DevToolsWarningStateService } from './devtools-warning-state.service';
import { GAME_ACCOUNT_BY_ROUTE } from '../game-account/game-account.config';

// THE inspect guard for every instant game - the only one running. It watches the whole time the
// player is on a game page (started/stopped by navigation, no per-game wiring), shows the shared
// warning card from the app root and sends the player to the home page. Games no longer carry
// their own guards, so nothing can fire twice. Bets are also refused while devtools is open (see
// ApiCallService), so dismissing the card doesn't let play continue.
// Same UI-deterrent caveat as DevToolsGuardService: the real protection is server-side.
@Injectable({ providedIn: 'root' })
export class GameGuardService {
  private router = inject(Router);
  private guard = inject(DevToolsGuardService);
  private warning = inject(DevToolsWarningStateService);
  private handle: DevToolsGuardHandle | null = null;
  private started = false;

  start(): void {
    if (this.started) return;
    this.started = true;

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.onNavigated(e.urlAfterRedirects));
    this.onNavigated(this.router.url);
  }

  private isGameUrl(url: string): boolean {
    const match = /^\/dashboard\/([^/?#]+)/.exec(url);
    if (!match) return false;
    const seg = match[1].toLowerCase();
    return seg === 'buy-now' || !!GAME_ACCOUNT_BY_ROUTE[seg];
  }

  private onNavigated(url: string): void {
    const onGame = this.isGameUrl(url);

    if (onGame && !this.handle) {
      this.handle = this.guard.start(
        () => true,
        (reason) => {
          console.warn(`[ANTI-TAMPER] ${reason}.`);
          this.warning.show('Unusual activity detected on your account. Please try again later.');
          this.router.navigate(['/dashboard/home']);
        },
      );
    } else if (!onGame && this.handle) {
      this.handle.stop();
      this.handle = null;
    }
  }
}
